import React from 'react'

const Background = () => (
  <div className="min-h-inherit w-100 absolute">
    <div
      className="min-h-inherit w-100 absolute"
      style={{boxShadow: 'rgba(0, 0, 0, 0.5)', background: '#2F2F2F'}}
    />
    <div
      className="absolute w-100"
      style={{
        background:
          'linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.33) 98.41%)',
        height: 162,
        transform: 'rotate(-180deg)'
      }}
    />
    <div
      className="absolute w-100"
      style={{
        background:
          'linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.741904) 98.41%)',
        height: 162,
        bottom: 0
      }}
    />
  </div>
)

export default Background



// WEBPACK FOOTER //
// ./src/routes/Registration/Background.js